import { Button, buttonVariants, H1, MultilineCode, P } from '@samera-one/ui';
import { AxiosError, isAxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

const API_ERROR_PREFIX = 'errors:api';

type ErrorHandlerProps = {
  error: Error | AxiosError;
  resetErrorBoundary?: (...args: unknown[]) => void;
};

export const ErrorHandler = (props: ErrorHandlerProps) => {
  const { error, resetErrorBoundary } = props;

  const { t, i18n } = useTranslation();

  const errorMessages = isAxiosError(error) ? error.response?.data : undefined;

  const hasTranslatedErrors =
    errorMessages &&
    errorMessages.length > 0 &&
    errorMessages.every((message: string) =>
      i18n.exists(`${API_ERROR_PREFIX}.${message}`),
    );

  return (
    <main className="flex-1 flex justify-center items-center px-4">
      <div className="flex flex-col gap-4 items-center max-w-full text-center">
        <H1>{t('errors:somethingWentWrong')}</H1>
        {hasTranslatedErrors && (
          <P className="text-muted-foreground">
            {errorMessages.map((message: string) => (
              <span key={message}>
                {t(`${API_ERROR_PREFIX}.${message}`)}
                <br />
              </span>
            ))}
          </P>
        )}

        {import.meta.env.DEV && (
          <MultilineCode className="max-w-full">
            <pre>{error.stack}</pre>
          </MultilineCode>
        )}
        <div className="flex gap-2">
          <Button type="button" variant="outline" onClick={resetErrorBoundary}>
            {t('buttons.tryAgain')}
          </Button>
          <a href={'/'} type="button" className={buttonVariants()}>
            {t('buttons.toHomePage')}
          </a>
        </div>
      </div>
    </main>
  );
};
